import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/client-scripts`;

export const clientScriptsApi = {
  doctypes: () => axios.get(`${BASE}/doctypes`),
  active: (doctype) => axios.get(`${BASE}/active/${doctype}`),
  list: (params = {}) => axios.get(BASE, { params }),
  get: (id) => axios.get(`${BASE}/${id}`),
  create: (payload) => axios.post(BASE, payload),
  update: (id, payload) => axios.put(`${BASE}/${id}`, payload),
  remove: (id) => axios.delete(`${BASE}/${id}`),
};

export default clientScriptsApi;
